import IntegrationPartnerProvider from './IntegrationPartnerProvider'

export default IntegrationPartnerProvider

export { default as useIntegrationPartner } from './hooks/useIntegrationPartner'
